var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-footer',{attrs:{"pagination":_vm.pagination,"options":_vm.options,"items-per-page-options":[20, -1]},on:{"update:options":_vm.updateOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }